<template>
   <div class="maincontainer pt-3 pl-5 pr-5">
        <div class="mb-2">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        <div class="row w-full mb-3 justify-between flex" style="align-items: center">
            <h1 class="title">Risk History - {{mainRiskObject.risk}}</h1>
        </div>
        <div class="mt-3 text-xs">
            Risk history is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities,
            strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can
            help determine how best to identify, manage and mitigate significant risks.
        </div>
        <div class="bg-white border-lightgrey border rounded-t mt-4 w-full">
            <div class="flex p-3 items-center justify-between">
                <h1 class="title ml-5">Risk History</h1>
                <div class=" flex justify-center items-center">
                    <div class=" flex justify-center items-center">
                        <button class="btnprimary w-24 flex taskEditButtons" v-if="oldComments" @click="sortWorkLog()">
                            <img src="@/assets/sortByPrimary.svg" class="h-3 mr-2.5 rotate-180" />
                            Newest
                        </button>
                        <button class="btnprimary w-24 flex taskEditButtons" v-if="!oldComments" @click="sortWorkLog()">
                            <img src="@/assets/sortByPrimary.svg" class="h-3 mr-2.5" />
                            Oldest
                        </button> 
                    </div>
                </div>
            </div>
        </div>
        <div v-for="work in workLogObject" :key="work" class="bg-white p-4 border-lightgrey border w-full">
            <div class="flex ml-4">
                <div v-if="(Object.keys(work).includes('createdBy'))" class="initials cursor-pointer">
                    {{  
                        extractInitials(work.name !=undefined?work.name:getPersonName(work.createdBy)) 
                    }}
                </div>
                <div class="logContainer">
                    <div class="flex">
                        <p v-if="(Object.keys(work).includes('createdBy'))" class="font-semibold cursor-pointer text-xs">
                            {{  
                                work.name !=undefined?work.name:getPersonName(work.createdBy)
                            }}
                        </p>
                        
                        <p v-if="(((Object.keys(work).includes('previousStatus') && work.previousStatus == null) || !Object.keys(work).includes('previousStatus') ) && work.actionEntity == 10301)" class="mx-2 text-xs">{{"Created the risk status on"}}</p>
                        <p v-else-if="work.actionEntity == 10302 && (!Object.keys(work).includes('previousStatus'))" class="mx-2 text-xs">{{"Updated the Risk on"}}</p>
                        
                        <p v-else-if="work.statusCode == 0 && work.action==10407" class="mx-2 text-xs">{{'Rejected the Reset Request Request on'}}</p>
                        <p v-else-if="work.statusCode == 0 && work.action==10403" class="mx-2 text-xs">{{'Rejected the Accept Request Request on'}}</p>
                        <p v-else-if="work.statusCode == 0 && work.action==10405" class="mx-2 text-xs">{{'Rejected the Mitigation Task Request on'}}</p>
                        <p v-else-if="work.statusCode == 0 && work.action==10404" class="mx-2 text-xs">{{'Rejected the Delete Request Request on'}}</p>

                        <p v-else-if="(work.previousStatus == work.updatedStatus) && work.action==10403" class="mx-2 text-xs">{{'Created the Accept Request to the risk on'}}</p>
                        <p v-else-if="(work.previousStatus == work.updatedStatus) && work.action==10405" class="mx-2 text-xs">{{'Created the Mitigate Tasks to the risk on'}}</p>
                        <p v-else-if="(work.previousStatus == work.updatedStatus) && work.action==10407" class="mx-2 text-xs">{{'Created the Reset Request to the risk on'}}</p>
                        <p v-else-if="(work.previousStatus == work.updatedStatus) && work.action==10404" class="mx-2 text-xs">{{'Created the Delete Request to the risk on'}}</p>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined" class="flex text-xs">
                            <p class="px-2 text-xs">Updated the risk on</p>
                            
                        </div>
                        <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('isControlsExist') && work.isControlsExist!=undefined && work.isControlsExist==true)" class="flex text-xs">
                            <p class="px-2 text-xs">Updated the risk on</p>
                        </div>
                        <p  v-else class="mx-2 text-xs">{{"Changed the risk status on"}}</p>

                        <p v-if="(Object.keys(work).includes('createdAt'))" class="font-semibold cursor-pointer text-xs">{{formatTime(work.createdAt)}}</p>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined" class="flex pt-2 text-xs">
                        <p class="capitalize font-semibold text-xs">priority</p>
                        <p class="px-2 text-xs"> is changed from </p>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">risk</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div> 
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">risk category</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">threat source</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">threat category</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">vulnerability</p>
                        <p class="px-2 text-xs"> is changed from </p>
                            
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Risk Owner</p>
                        <p class="px-2 text-xs"> is changed from </p>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Threat</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Financial</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Startegic</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Operations</p>
                        <p class="px-2 text-xs"> is changed from </p>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">Compliance</p>
                        <p class="px-2 text-xs"> is changed from </p>
                        
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">likelihood</p>
                        <p class="px-2 text-xs"> is changed from </p>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined" class="flex text-xs pt-2">
                        <p class="capitalize font-semibold text-xs">OverallImpact</p>
                        <p class="px-2 text-xs"> is changed from </p>
                    </div>
                    <div 
                        v-if="work.actionEntity == 10302 
                            && Object.keys(work).includes('additionalInfo')
                            && work.additionalInfo?.controls !== undefined 
                            && work.additionalInfo.controls.length > 0" 
                        class="flex text-xs pt-2"
                        >
                        <div class="flex flex-col">
                            <p 
                                v-for="control in work.additionalInfo.controls" 
                                :key="control.controlId"
                                class="text-xs"
                            >
                                <span class="font-semibold mt-1">{{ control.clientUniqueId.toUpperCase() }}</span> --
                                {{ control.controlTitle }}
                                -- <span class="font-semibold mt-1">{{ control.weightage }}%</span>
                            </p>
                        </div>
                        </div>
                    <div v-if="work.actionEntity == 10302 && (!Object.keys(work).includes('previousStatus'))"  class="mt-4 ml">
                        <!-- {{Object.keys(work.additionalInfo.risk.oldRisk[0])}}    -->

                        <div v-for="objKey in Object.keys(work.additionalInfo.risk.oldRisk[0])" :key="objKey">
                            <div v-if="objKey == 'riskOwner'" class="flex pt-1 text-xs">

                                <p class="capitalize font-semibold text-xs">{{objKey}}</p>
                                <p class="px-2 text-xs"> is changed from </p>

                                <p class="capitalize font-semibold text-xs">
                                    {{
                                        getPersonName(work.additionalInfo.risk.oldRisk[0][objKey])                                        
                                    }}
                                </p>

                                <div class="px-3 flex items-center"><img src="@/assets/arrowRight.svg"/></div>

                                <p class="capitalize font-semibold text-xs">
                                    {{
                                        getPersonName(work.additionalInfo.risk.newRisk[0][objKey])
                                    }}
                                </p>

                            </div>
                            <div v-else-if="objKey == 'priority'" class="flex pt-1 text-xs">

                                <p class="capitalize font-semibold text-xs">{{objKey}}</p>
                                <p class="px-2 text-xs"> is changed from </p>

                                <div v-if="!isNaN(work.additionalInfo.risk.oldRisk[0][objKey])" class="flex items-center justify-center rounded-full ml-2 w-6 h-6" :class="colorPriorityBg(work.additionalInfo.risk.oldRisk[0][objKey])">
                                    <div :class="colorPriorityText(work.additionalInfo.risk.oldRisk[0][objKey])">
                                        {{getPriorityLabel(work.additionalInfo.risk.oldRisk[0][objKey])}}
                                    </div>
                                </div>

                                <div class="px-3 flex items-center"><img src="@/assets/arrowRight.svg"/></div>

                                <div v-if="!isNaN(work.additionalInfo.risk.newRisk[0][objKey])" class="flex items-center justify-center rounded-full ml-2 w-6 h-6" :class="colorPriorityBg(work.additionalInfo.risk.newRisk[0][objKey])">
                                    <div :class="colorPriorityText(work.additionalInfo.risk.newRisk[0][objKey])">
                                        {{getPriorityLabel(work.additionalInfo.risk.newRisk[0][objKey])}}
                                    </div>
                                </div>

                            </div>
                            <div v-else class="flex py-1">

                                <p class="capitalize font-semibold text-xs">{{objKey}}</p>
                                <p class="px-2 text-xs"> is changed from </p>
                                
                                <div v-if="!isNaN(work.additionalInfo.risk.oldRisk[0][objKey])" class="flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5" :class="colorRiskParameterText(work.additionalInfo.risk.oldRisk[0][objKey])">
                                    <div class="w-full h-full absolute rounded" :class="colorRiskSeverity(work.additionalInfo.risk.oldRisk[0][objKey])"></div>
                                    <div class="flex rounded w-28 items-center regular text-xs">
                                        <div >
                                            <div class="flex w-28 items-center justify-center regular pb-px">
                                                {{getRiskValue(work.additionalInfo.risk.oldRisk[0][objKey],objKey)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <div v-else>
                                    <div><p class="font-semibold text-xs">{{work.additionalInfo.risk.oldRisk[0][objKey]}}</p></div>
                                </div>

                                <div class="px-3 flex items-center"><img src="@/assets/arrowRight.svg"/></div>

                                <div v-if="!isNaN(work.additionalInfo.risk.newRisk[0][objKey])" class="flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5" :class="colorRiskParameterText(work.additionalInfo.risk.newRisk[0][objKey])">
                                    <div class="w-full h-full absolute rounded" :class="colorRiskSeverity(work.additionalInfo.risk.newRisk[0][objKey])"></div>
                                    <div class="flex rounded w-28 items-center regular text-xs">
                                        <div>
                                            <div class="flex w-28 items-center justify-center regular pb-px">
                                                {{getRiskValue(work.additionalInfo.risk.newRisk[0][objKey],objKey)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="font-semibold text-xs">{{work.additionalInfo.risk.newRisk[0][objKey]}}</p>
                                </div>

                            </div>
                        </div>

                    </div>
                    
                    <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.priority !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.priority !== undefined" class="flex text-xs mt-4">
                        
                        <!-- OLD -->
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length"
                            class="rounded h-5 w-28 flex items-center justify-center"
                            :class="colorPriorityBg(work.additionalInfo.risk.oldRisk[0].priority)">
                            
                            <div :class="colorPriorityText(work.additionalInfo.risk.oldRisk[0].priority)">
                            {{ getPriorityLabel(work.additionalInfo.risk.oldRisk[0].priority)||'N/A' }}
                            </div>
                        </div>

                        <div class="px-3 flex items-center">
                            <img src="@/assets/arrowRight.svg"/>
                        </div>

                        <!-- NEW -->
                        <div v-if="work.additionalInfo?.risk?.newRisk?.length"
                            class="rounded h-5 w-28 flex items-center justify-center"
                            :class="colorPriorityBg(work.additionalInfo.risk.newRisk[0].priority)">
                            
                            <div :class="colorPriorityText(work.additionalInfo.risk.newRisk[0].priority)">
                            {{ getPriorityLabel(work.additionalInfo.risk.newRisk[0].priority)||'N/A' }}
                            </div>
                        </div>

                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.risk !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.risk !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ work.additionalInfo.risk.oldRisk[0].risk||'N/A'}}
                        </div>
                        <p class="px-2 text-xs">to</p>
                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].risk||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskCategory !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ work.additionalInfo.risk.oldRisk[0].riskCategory||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].riskCategory||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatSource !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatSource !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ work.additionalInfo.risk.oldRisk[0].threatSource||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].threatSource||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatCategory !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatCategory !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ work.additionalInfo.risk.oldRisk[0].threatCategory||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].threatCategory||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.vulnerability !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.vulnerability !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ work.additionalInfo.risk.oldRisk[0].vulnerability||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].vulnerability||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.riskOwner !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.riskOwner !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getPersonName(work.additionalInfo.risk.oldRisk[0].riskOwner?.value)||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ getPersonName(work.additionalInfo.risk.newRisk[0].riskOwner?.value)||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.threatEvent !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.threatEvent !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{work.additionalInfo.risk.oldRisk[0].threatEvent||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ work.additionalInfo.risk.newRisk[0].threatEvent||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.financial !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.financial !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{getRiskValue(work.additionalInfo.risk.oldRisk[0].financial,'financial')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{ getRiskValue(work.additionalInfo.risk.newRisk[0].financial,'financial')||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.business !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.business !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getRiskValue(work.additionalInfo.risk.oldRisk[0].business,'business')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{getRiskValue(work.additionalInfo.risk.newRisk[0].business,'business')||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.operations !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.operations !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getRiskValue(work.additionalInfo.risk.oldRisk[0].operations,'operations')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{getRiskValue( work.additionalInfo.risk.newRisk[0].operations,'operations')||'N/A'}}
                        </div>
                    </div>
                    <div v-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.legal !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.legal !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getRiskValue(work.additionalInfo.risk.oldRisk[0].legal,'legal')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{getRiskValue( work.additionalInfo.risk.newRisk[0].legal,'legal')||'N/A'}}
                        </div>
                    </div>
                    <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.likelihood !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.likelihood !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getRiskValue(work.additionalInfo.risk.oldRisk[0].likelihood,'likelihood')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{getRiskValue(work.additionalInfo.risk.newRisk[0].likelihood,'likelihood')||'N/A'}}
                        </div>
                    </div>
                    <div v-else-if="work.actionEntity == 10302 && (Object.keys(work).includes('additionalInfo'))&&work.additionalInfo?.risk?.oldRisk?.[0]?.overallImpact !== undefined &&work.additionalInfo?.risk?.newRisk?.[0]?.overallImpact !== undefined" class="flex text-xs pt-2">
                        <div v-if="work.additionalInfo?.risk?.oldRisk?.length" class="capitalize font-semibold text-xs">
                            {{ getRiskValue(work.additionalInfo.risk.oldRisk[0].overallImpact,'overallImpact')||'N/A'}}
                        </div>

                        <p class="px-2 text-xs">to</p>

                        <div v-if="work.additionalInfo?.risk?.newRisk?.length" class="capitalize font-semibold text-xs mr-2">
                            {{getRiskValue(work.additionalInfo.risk.newRisk[0].overallImpact,'overallImpact')||'N/A'}}
                        </div>
                    </div>
                    <div v-if="Object.keys(work).includes('insertedIds')">
                        <div v-for="task in work.insertedIds" :key="task" class="flex pt-2">
                            <p class="text-xs">Approval:</p>
                            <p class="font-semibold px-2 hover:underline cursor-pointer text-xs" @click="openTaskEdit(task)">{{getTaskInfo(task)}}</p>
                            <p class="text-xs">{{"is Created"}}</p>
                        </div>
                    </div>
                    <div v-if="Object.keys(work).includes('taskId')">
                        <div class="flex pt-2">
                            <p class="text-xs">TaskId:</p>
                            <p class="font-semibold px-2 hover:underline cursor-pointer text-xs" @click="openTaskEdit(work.taskId)">{{getTaskInfo(work.taskId)}}</p>

                            <p class="text-xs" v-if="work.statusCode == 1">{{"is closed by Accepting"}}</p>
                            <p class="text-xs" v-else-if="work.statusCode == 0">{{"is closed by Rejecting"}}</p>
                        </div>
                    </div>
                    <div class="flex items-center gap-2 mt-2" v-if="(work.justification != undefined && work.justification != '') || (work.additionalInfo && work.additionalInfo.justification)">
                        <p class="font-semibold text-xs">Justification :</p>
                        <p class="text-xs text-justify">{{ work.justification || work.additionalInfo.justification }}</p>
                    </div>
                    <div class="flex">
                        <div v-if="(Object.keys(work).includes('previousStatus') && (work.previousStatus != work.updatedStatus && work.previousStatus!=null)) || (!work.previousStatus==null && work.actionEntity == 10301)" class="relative mt-4" @mouseout="doFalse()">
                            <div class="flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5" :class="colorRiskText(work.previousStatus)">
                                <div class="w-full h-full absolute rounded" :class="colorRiskBg(work.previousStatus)"></div>
                                <div class="flex rounded w-28 items-center regular text-xs">
                                    <div v-if="!isNaN(work.previousStatus)">
                                        <div class="flex w-28 items-center justify-center regular pb-px">
                                            <!-- {{risksStatusValues.find((l) => {
                                                return l.id == work.previousStatus;
                                            }).value}} -->
                                            {{ getRiskStatusLabel(work.previousStatus) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="(Object.keys(work).includes('previousStatus') && (work.previousStatus != work.updatedStatus && work.previousStatus!=null)) || (!work.previousStatus==null)" class="mx-4 flex items-center  mt-4"><img src="@/assets/arrowRight.svg"/></div>
                        <div v-if="(work.previousStatus != work.updatedStatus)" class="relative  mt-4" @mouseout="doFalse()">
                            <div class="flex items-center cursor-pointer relative rounded w-28 regular text-xs h-5" :class="colorRiskText(work.updatedStatus)">
                                <div class="w-full h-full absolute rounded" :class="colorRiskBg(work.updatedStatus)"></div>
                                <div class="flex rounded w-28 items-center regular text-xs">
                                    <div v-if="!isNaN(work.updatedStatus)">
                                        <div class="flex w-28 items-center justify-center regular pb-px">
                                            <!-- {{risksStatusValues.find((l) => {
                                                return l.id == work.updatedStatus;
                                            }).value}} -->
                                            {{getRiskStatusLabel(work.updatedStatus)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.initials {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--color-primary);
  color: white;
  border-radius: 50%;
  margin-right: 14px;
}
.logContainer{
    padding-top: 5px;
}
.fontSizingForPriority{
    font-size: 10px !important;
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import breadCrumb from '@/components/breadCrumb.vue';
import moment from 'moment';
import store from '@/store';
import { mapGetters } from 'vuex';

export default defineComponent({
	data(): any {
        return{
            oldComments:true,
            workLogObject:[],
            mainRiskId:'',
            routesArray:[],
            tasksData:[],
            risksPriorityValue:[
                {
                    id:5,
                    value:'5',
                    label:'P1'
                },
                {
                    id:4,
                    value:'4',
                    label:'P2'
                },
                {
                    id:3,
                    value:'3',
                    label:'P3'
                },
                {
                    id:2,
                    value:'2',
                    label:'P4'
                },
                {
                    id:1,
                    value:'1',
                    label:'P5'
                },
            ],
            risksSeverityValue: [
                {
                    id: 1,
                    value: 'Very Low'
                },
                {
                    id: 2,
                    value: 'Low'
                },
                {
                    id: 3,
                    value: 'Moderate'
                },
                {
                    id: 4,
                    value: 'High'
                },
                {
                    id: 5,
                    value: 'Very High'
                }
            ],
            risksStatusValues: [
                
                {
                    id: 10401,
                    value: 'Open'
                },
                {
                    id: 10402,
                    value: 'In Progress'
                },
                {
                    id: 10403,
                    value: 'Closed'
                },
                {
                    id: 10425,
                    value: 'Monitered'
                },
                {
                    id: 10405,
                    value: 'Mitigated'
                },
                {
                    id: 10406,
                    value: 'Partial'
                },
                {
                    id:10407,
                    value:'Reset'
                },
                {
                    id:10409,
                    value:'On Hold'
                },
                {
                    id:10408,
                    value:'Approval'
                },
                {
                    id: 10404,
                    value: 'Invalid'
                },
                {
                    id:10419,
                    value:'Avoid'
                }
            ],
            orgUsersList:[],
            optionsUserArray:[],
    	    allSystems:[],
            tierRiskId:'',
            mainTierRiskName:'',
            businessProcessList:[],
            businessEntitiesList:[],
            mainRiskObject:{},
            allRiskArray:[]

        }
    },
    components: {
        breadCrumb,
    },
    computed:{
        ...mapGetters({ userInfo: 'userInfo',dbSeverity:'dbSeverity',dbLikelihood:'dbLikelihood',dbBussiness:'dbBussiness',
            dbOrganization:'dbOrganization',dbOperations:'dbOperations',dbLegal:'dbLegal',
            dbFinancial:'dbFinancial',dbTechnical:'dbTechnical',dbProcessCriticality:'dbProcessCriticality',
            dbAvailability:'dbAvailability',dbConfidentiality:'dbConfidentiality',dbIntegrity:'dbIntegrity',
            dbInformationClassification:'dbInformationClassification',dbSecurityCategory:'dbSecurityCategory',dbPriority:'dbPriority',dbOverAllImpact:'dbOverAllImpact' }),
    },
    methods: {
        sortWorkLog() {
            this.oldComments = !this.oldComments; 
            this.workLogObject?.sort().reverse();
        },
        openTaskEdit(taskId:any){
            let mainTask = this.tasksData.find((taskObj:any)=>{
                return taskObj._id == taskId;
            })
            if(mainTask.action == 10405){
                this.$router.push({ name: 'taskEditPage', params: { taskId: taskId } });
            }else{
                this.$router.push({ name: 'taskEditPage', params: { taskId: taskId }, query:{ approvals:true }});
            }
            
        },
        extractInitials(name:any) {
            const names = name.split(' ');
            return names.map((name:any) => name[0]).join('').toUpperCase();
        },
        doFalse() {
            this.pop = false;
        },
        formatTime(time:any){
            let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
        },
        getTaskInfo(taskIdNumber:any){
            let mainTask = this.tasksData.find((taskObj:any)=>{
                return taskObj._id == taskIdNumber;
            })
            if(mainTask != undefined){
                let formattedId = this.formatTaskId(mainTask.taskId);
                return formattedId;
            }else{
                return ''
            }
        },
        formatTaskId(taskId:any) {
            return taskId.toString().padStart(4, '0');
        },
        colorPriorityText(priority: any) {
			if (priority == 1) {
				return ['text-lightgreen font-semibold'];
			} else if (priority == 2) {
				return ['text-green font-semibold'];
			} else if (priority == 3) {
				return ['text-yellow font-semibold'];
			} else if (priority == 4) {
				return ['text-error font-semibold'];
			} else if (priority == 5) {
				return ['text-darkred font-semibold'];
			}
		},
         colorPriorityBg(priority: any) {
			if (priority == 1) {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (priority == 2) {
				return ['bgGreen border-solid border border-green'];
			} else if (priority == 3) {
				return ['bgYellow border-solid border border-yellow'];
			} else if (priority == 4) {
				return ['bgError border-solid border border-error'];
			} else if (priority == 5) {
				return ['bgdarkred border-solid border border-darkred'];
			}
		},
        
        colorRiskText(Status: any) {
            if (Status == 10401) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            } else if (Status == 10402) {
                return ['text-electricGreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-electricGreen'];
            } else if (Status == 10403) {
                return ['text-primary', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-primary'];
            } else if (Status == 10405) {
                return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
            } else if (Status == 10406) {
                return ['text-yellow', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-yellow'];
            } else if (Status == 10407 || Status == 10425) {
                return ['text-resetBlue', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-resetBlue'];
            }else if (Status == 10409) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            } else if (Status == 10408) {
                return ['text-primary', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-primary'];
            }else if (Status == 10404) {
                return ['text-primary', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-primary'];
            }else if( Status==10419){
                return['text-green','flex justify-center px-2.5 py-1 font-semibold border-solid border border-green']
            }
        },
         colorRiskBg(Status: any) {
            if (Status == 10401) {
                return ['bg-darkred', 'opacity-10'];
            } else if (Status == 10402) {
                return ['bg-electricGreen', 'opacity-10'];
            } else if (Status == 10403) {
                return ['bg-primary', 'opacity-10'];
            } else if (Status == 10405) {
                return ['bg-lightgreen', 'opacity-10'];
            } else if (Status == 10406) {
                return ['bg-yellow', 'opacity-10'];
            } else if (Status == 10407 || Status == 10425) {
                return ['bg-resetBlue', 'opacity-10'];
            } else if (Status == 10409) {
                return ['bg-darkred', 'opacity-10'];
            } else if (Status == 10408) {
                return ['bg-primary', 'opacity-10'];
            } else if (Status == 10404) {
                return ['bg-primary', 'opacity-10'];
            } else if(Status==10419){
             return ['bg-green', 'opacity-15'];   
            }
        },
        colorRiskSeverity(status: any) {
            if (status == 1) {
                return ['bg-lightgreen opacity-10'];
            } else if (status == 2) {
                return ['bg-green opacity-10'];
            } else if (status == 3) {
                return ['bg-yellow opacity-10'];
            } else if (status == 4) {
                return ['bg-error opacity-10'];
            } else if (status == 5) {
                return ['bg-darkred opacity-10'];
            }
        },
        colorRiskParameterText(status: any) {
            if (status == 1) {
                return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
            } else if (status == 2) {
                return ['text-green', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-green'];
            } else if (status == 3) {
                return ['text-yellow', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-yellow'];
            } else if (status == 4) {
                return ['text-error', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-error'];
            } else if (status == 5) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            }
        },
        toolTipColorRiskText(Status: any) {
            if (Status == 10401) {
                return ['text-darkred'];
            } else if (Status == 10402) {
                return ['text-electricGreen'];
            } else if (Status == 10403) {
                return ['text-primary'];
            } else if (Status == 10405) {
                return ['text-lightgreen'];
            } else if (Status == 10406) {
                return ['text-yellow'];
            } else if (Status == 10407 || Status == 10425) {
                return ['text-resetBlue'];
            } else if (Status == 10409) {
                return ['text-darkred'];
            } else if (Status == 10408) {
                return ['text-primary'];
            }
        },
         async getallUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.orgUsersList = res.data;
                this.orgUsersList = this.orgUsersList.filter((user: any) => {
                    return user.isActive == true;
                });
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
                }
            });
        },
        getPersonName(person:any){
            let personObj = this.orgUsersList.find((user:any)=>{
                                return user._id == person
                            })
            if(personObj == undefined){
                return ''
            }else{
                return personObj.name;
            }
        },
        async getWorkLog() {
            await this.$http
                .get(`${process.env.VUE_APP_RISK_API}/api/org/riskhistory/getall`)
                .then((result: any) => {
                    if (result.data.length > 0) {
                        const mainObject: any = result.data.find(
                            (obj:any) => obj.linkedRiskId == this.mainRiskId
                        );
                        this.workLogObject = [...mainObject.riskHistory];
                    }
                });
            this.workLogObject?.sort().reverse();
        },
        getRiskStatusLabel(id:any){
            let name = this.risksStatusValues.find((l:any) => {return l.id == id;})
            if(name == undefined){
                return ''
            }else{
                return name.value;
            }
        },
        getPriorityLabel(cameId:any){
            let labelObj = this.dbPriority.find((l:any) => {return l.value == cameId;})
            if(labelObj == undefined){
                return ''
            }else{
                return labelObj.key;
            }                               
        },
        getRiskValue(idNum:any,key:any){
            let valueObj;

            if(key == 'operations'){
                valueObj = this.dbOperations.find((l:any) => {return l.value == idNum;})
            }else if(key=='business'){
                valueObj = this.dbBussiness.find((l:any) => {return l.value == idNum;})
            }else if(key=='legal'){
                valueObj = this.dbLegal.find((l:any) => {return l.value == idNum;})
            }else if(key=='financial'){
                valueObj = this.dbFinancial.find((l:any) => {return l.value == idNum;})
            }else if(key=='likelihood'){
                valueObj = this.dbLikelihood.find((l:any) => {return l.value == idNum;})
            }else if(key=='overallImpact'){
                valueObj=this.dbOverAllImpact.find((l:any) => {return l.value == idNum;})
            }

            if(valueObj == undefined){
                return ''
            }else{
                return valueObj.key;
            }                                 
        },
        async getSystems() {
            let entityId = '20005';
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.allSystems = result.data.map((sys: any) => {
                    return { value: sys._id, label: sys.systemName };
                });
            });
        },
        async getBusinessProcess(){
            this.businessProcessList = [];
            this.tableRow = [];
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
                result.data.forEach((entity: any) => {
                    this.businessProcessList.push(entity)
                });
            })
        },
        async getAllOrganizations() {
            this.businessEntitiesList = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any) => {
                result.data.map((object: any)=>{
                    this.businessEntitiesList.push(object)
                })
            });
        },
        async getAllTasks(){
             await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/tasks/getall`).then((result: any) => {
                this.tasksData = result.data;
            });
        },
        async getAllRisks(){
            this.allRiskArray = []
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/risks/getall`).then((result: any) => {
                this.allRiskArray = result.data
            })
        }
        },
        async mounted(){
            await this.getAllRisks();

            if(Object.keys(this.$route.query).includes('systems') || this.$route.path.includes('/worklog/system')){
                await this.getSystems();
                this.tierRiskId = this.$route.params.systemId;
                let systemDetails = this.allSystems.find((obj:any)=>{return obj.value == this.tierRiskId});
                this.mainTierRiskName = systemDetails.label
            }else if(Object.keys(this.$route.query).includes('process') || this.$route.path.includes('/worklog/process')){
                await this.getBusinessProcess();
                this.tierRiskId = this.$route.params.processId;
                let processDetails = this.businessProcessList.find((obj:any)=>{return obj._id == this.tierRiskId});
                this.mainTierRiskName = processDetails.businessProcessName
            }else if(Object.keys(this.$route.query).includes('organization') || this.$route.path.includes('/worklog/org')){
                await this.getAllOrganizations();
                this.tierRiskId = this.$route.params.orgId;
                let orgDetails = this.businessEntitiesList.find((obj:any)=>{return obj._id == this.tierRiskId});
                this.mainTierRiskName = orgDetails.entityName
            }
            
            this.mainRiskId = this.$route.params.riskId;

            let findRisk = this.allRiskArray.find((obj:any)=>{return obj._id == this.$route.params.riskId; })
            this.mainRiskObject = {...findRisk};

            await this.getAllTasks();
            if(this.$route.query.inActive){
                this.routesArray = [
                    { name: 'Inactive Risks', routeName: 'inActiveRisks' },
                    { name: 'Risk History', routeName: 'worklog' }
                ];
            }
            else if(this.$route.path.includes('/worklog') && Object.keys(this.$route.query).includes('Risks')){
                this.routesArray = [{name:'Risks',routeName:'risks'},{name:'Tier-Risks',routeName:'tierRisks',id: this.mainRiskObject.mappedRisk},{name:'Risk History',routeName:'worklog'}]

            }else if(Object.keys(this.$route.params).includes('processId')){
                this.routesArray = [{name:'Business Process',routeName:'businessProcess'},{ name: `${this.mainTierRiskName}`, routeName: 'processInformation', id: `${ this.$route.params.processId}` },{name: `${this.mainRiskObject.risk}`,routeName:'worklog'}]
            }else if(Object.keys(this.$route.params).includes('orgId')){
                this.routesArray = [{name:'Organization',routeName:'organization'},{ name: `${this.mainTierRiskName}`, routeName: 'organizationInformation', id: `${ this.$route.params.orgId}` },{name:`${this.mainRiskObject.risk}`,routeName:'worklog'}]
            }else if(Object.keys(this.$route.params).includes('systemId')){
                this.routesArray = [
                    { name: 'Systems', routeName: 'systems' },
                    { name: `${this.mainTierRiskName}`, routeName: 'systemInformation', id: `${this.$route.params.systemId}`},
                    {name: `${this.mainRiskObject.risk}`,routeName:'worklog'}
                ];
            }
            await this.getallUsers()
            await this.getWorkLog();
        },

});
</script>
